/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React, { useEffect, useState } from 'react';
import {
    string, func, object, bool,
} from 'prop-types';
import { withStyles } from '@material-ui/core';

const styles = (theme) => ({
    quantityContainer: {
        alignItems: 'center',
        height: '56px',
        marginRight: '16px',
        '@media screen and (max-width: 600px)': {
            justifyContent: 'center',
            marginRight: '12px',
        },
    },
    mainContainer: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: '168px',
        minWidth: '83px',
        outline: '1px solid #C4C4C4',
        borderRadius: '3px',
    },
    addIcon: {
        padding: '0px',
        backgroundColor: 'transparent',
        fontSize: '24px',
        border: 'unset',
        display: 'flex',
        cursor: 'pointer',
        width: '12px',
        height: '12px',
        outlineColor: 'transparent',
        margin: '0 auto',
        justifyContent: 'center',
        alignItems: 'center',
    },
    inputField: {
        maxWidth: '33%',
        height: '56px',
        padding: '4px 0px',
        textAlign: 'center',
        borderTop: 'unset',
        borderBottom: 'unset',
        border: '1px solid #C4C4C4',
        fontSize: '16px',
        lineHeight: '20px',
        fontFamily: 'Area Variable',
        outlineColor: 'transparent',
    },
    removeIcon: {
        padding: '0px',
        backgroundColor: 'transparent',
        fontSize: '24px',
        border: 'unset',
        display: 'flex',
        cursor: 'pointer',
        width: '12px',
        height: '12px',
        outlineColor: 'transparent',
        margin: '0 auto',
        justifyContent: 'center',
        alignItems: 'center',
        '& svg': {
            fill: '#000000',
        },
    },
    disabledButton: {
        '& svg': {
            fill: '#D9D9D9',
            cursor: 'default',
        },
    },
    errorMessage: {
        color: theme.palette.cms?.errorMessage || '#DF3030',
        fontSize: '14px',
        lineHeight: '16px',
        fontFamily: 'LatoBold, Lato, Arial, Verdana, sans-serif',
        position: 'absolute',
        bottom: '0px',
        '@media screen and (max-width: 600px)': {
            bottom: '-5px',
        },
    },
});

const ProductStepperQuantity = ({
    quantity,
    setProductQuantity,
    classes,
}) => {
    const [textFieldValue, setTextFieldValue] = useState(quantity);
    const [errorMessage, setErrorMessage] = useState(false);
    const handleTextFieldChange = (e) => {
        // RegEx to get range between 1 - 99
        const rangeRegex = (/^[1-9][0-9]?$|^99$/);
        if (rangeRegex.test(e.target.value) || e.target.value === '') {
            const value = e.target.value !== '' ? Number(e.target.value) : '';
            setTextFieldValue(value);
            setErrorMessage(false);
            if (value !== '') {
                setProductQuantity(Number(value));
            }
        }
    };

    useEffect(() => {
        setTextFieldValue(quantity);
    }, [quantity]);
    const handleBlur = () => {
        const value = (textFieldValue === 0 || textFieldValue === '') ? '1' :  textFieldValue;
        setProductQuantity(value);
        setTextFieldValue(value);
    };
    const addProductQuantity = () => {
        if (Number(quantity) === 99) {
            setErrorMessage(true);
        } else {
            setProductQuantity(Number(quantity) + 1);
            setErrorMessage(false);
        }
    };
    return (
        <div className={classes.quantityContainer}>
            <div
                className={classes.mainContainer}
            >
                <button
                    type="button"
                    data-testid="decrementIcon"
                    className={textFieldValue === '' || Number(textFieldValue) <= 1 ? `${classes.disabledButton} ${classes.removeIcon}` : classes.removeIcon}
                    onClick={() => {
                        setProductQuantity(Number(quantity) - 1);
                        setErrorMessage(false);
                    }}
                    disabled={textFieldValue === '' || Number(textFieldValue) <= 1}
                    aria-label="Remove"
                >
                    <svg xmlns="http://www.w3.org/2000/svg" width="13" height="12" viewBox="0 0 13 12" fill="none">
                        <rect x="12" y="5.33337" width="1.33333" height="11" rx="0.5" transform="rotate(90 12 5.33337)"  />
                    </svg>
                </button>
                <input
                    type="text"
                    name="quantity"
                    label="quantity"
                    title="quantity"
                    onChange={(e) => {
                        e.stopPropagation();
                        e.preventDefault();
                        handleTextFieldChange(e);
                    }}
                    onBlur={() => {
                        handleBlur();
                    }}
                    value={textFieldValue || ''}
                    className={classes.inputField}
                />
                <button
                    type="button"
                    data-testid="incrementIcon"
                    className={classes.addIcon}
                    onClick={() => {
                        addProductQuantity();
                    }}
                    aria-label="Add"
                >
                    <svg xmlns="http://www.w3.org/2000/svg" width="13" height="12" viewBox="0 0 13 12" fill="none">
                        <rect x="6.00024" y="0.5" width="1" height="11" rx="0.5" fill="#000000" stroke="#000000" />
                        <rect x="12" y="5.64282" width="1" height="11" rx="0.5" transform="rotate(90 12 5.64282)" fill="#000000" stroke="#000000" />
                    </svg>
                </button>
            </div>
            {errorMessage && <span className={classes.errorMessage}>Maximum quantity 99 allowed</span>}
        </div>
    );
};

ProductStepperQuantity.propTypes = {
    quantity: string.isRequired,
    setProductQuantity: func.isRequired,
    classes: object.isRequired,
};

export default withStyles(styles)(ProductStepperQuantity);
